import { Skeleton } from '@mui/material'

const SkeletonTokenName = () => {
  return <Skeleton sx={{ width: '200px' }} />
}

export default SkeletonTokenName
